import { BookOpen, BrainCircuit, Link as LinkIcon, Quote, Scale, Search } from 'lucide-react';
import type { FeatureContent } from './types';

export const ricercaEQuesiti: FeatureContent = {
  slug: 'ricerca-e-quesiti',
  navLabel: 'Quesiti',
  menuDescription:
    'Poni il quesito, approfondisci la risposta e verifica le fonti utilizzate, con riferimenti diretti ai documenti originali.',
  cardDescription:
    'Descrivi il caso. Trovanorma ricostruisce il quadro normativo, giurisprudenziale e di prassi e ti permette di verificare i riferimenti utilizzati.',
  meta: {
    title: 'Ricerca normativa e quesiti con AI',
    description:
      'Descrivi il caso e ricevi un’analisi argomentata. Trovanorma ricostruisce normativa, prassi e giurisprudenza e collega i riferimenti ai documenti originali.',
  },
  hero: {
    title: 'Quesiti',
    subtitle:
      'Descrivi il caso: Trovanorma ricostruisce il quadro normativo, giurisprudenziale e di prassi e ti permette di verificare i riferimenti utilizzati.',
    image: {
      src: '/images/how-it-works/screen.webp',
      alt: 'Interfaccia di Trovanorma con un quesito e la risposta documentata con fonti',
      width: 900,
      height: 440,
    },
  },
  statement: 'Non solo una risposta, ma il quadro completo per sostenerla',
  statementText:
    'Trovanorma mette in relazione normativa, prassi e giurisprudenza rilevanti per il tuo quesito, così puoi arrivare a una conclusione documentata e verificarne i riferimenti.',
  blocks: [
    {
      icon: BrainCircuit,
      kicker: 'Quesiti professionali',
      title: 'Parti dal problema, non dalla ricerca',
      description:
        'Descrivi il caso con parole tue: da un dubbio fiscale a una questione procedurale, da un adempimento a un’interpretazione del CCNL.',
    },
    {
      icon: Scale,
      kicker: 'Quadro di riferimento',
      title: 'Normativa, prassi e giurisprudenza messe in relazione',
      description:
        'Trovanorma individua e collega i riferimenti rilevanti per ricostruire il quadro applicabile al tuo quesito.',
    },
    {
      icon: Quote,
      kicker: 'Orientamenti e interpretazioni',
      title: 'Vai oltre il singolo riferimento',
      description:
        'Approfondisci orientamenti giurisprudenziali, prassi amministrativa e interpretazioni rilevanti per valutare il caso da più prospettive.',
    },
    {
      icon: BookOpen,
      kicker: 'Documenti di riferimento',
      title: 'Arriva subito al passaggio che conta',
      description:
        'Consulta sintesi strutturate di pronunce, interpelli, normativa e CCNL per individuare più rapidamente gli elementi rilevanti.',
    },
    {
      icon: LinkIcon,
      kicker: 'Verifica delle fonti',
      title: 'Dalla risposta alla fonte originale',
      description:
        'Ogni citazione è cliccabile: apri direttamente il documento di riferimento e, quando indicato, l’articolo richiamato.',
    },
    {
      icon: Search,
      kicker: 'Ricerca nelle fonti',
      title: 'Cerca nelle fonti anche senza partire da un quesito',
      description:
        'Consulta direttamente normativa, prassi e giurisprudenza, come in una banca dati professionale.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Descrivi il quesito',
      description: 'Esponi il caso, il dubbio o la problematica in linguaggio naturale.',
    },
    {
      step: 2,
      title: 'Trovanorma ricostruisce il quadro',
      description:
        'Analizza normativa, prassi e giurisprudenza pertinenti e mette in relazione i riferimenti rilevanti.',
    },
    {
      step: 3,
      title: 'Verifica e approfondisci',
      description:
        'Ricevi una risposta argomentata, consulta le fonti citate e continua la conversazione sui punti che vuoi approfondire.',
    },
  ],
  relatedSolutions: ['avvocati', 'commercialisti'],
  closing: {
    title: 'Porta un quesito reale',
    text: 'Porta un caso reale e verifica direttamente come Trovanorma ricostruisce il quadro, argomenta la risposta e collega i riferimenti ai documenti originali.',
  },
};
